import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Notification, NotificationLink, NotificationType } from '../../models/gung-notification/gung-notification';

@Injectable({
  providedIn: 'root'
})
export class GungNotificationService {
  private notificationSubject: BehaviorSubject<Notification> = new BehaviorSubject<Notification>(null);

  /**
   * Shows a notification to the user as a toast (rendered by `<lib-gung-notification>`, already in
   * every app wrapper). This is the only way to show one; do not render a notification component.
   * @param title Translation key or text, shown on the toast's top row. When empty, the message is
   * shown there instead and the toast has no body.
   * @param message Translation key or text, shown below the title while the toast is open
   * @param type 'success' | 'warning' | 'error'; 'danger' shows as error, anything else as info
   * @param link Makes the message (or the title, when there is no message) a router link
   * @param notificationTime How long the toast stays, in ms (default 6000); hovering pauses it
   * @param customClass Classes added to the toast; 'center-notification' shows it bottom-center
   */
  public notify(title: string, message: string, type: NotificationType, link?: NotificationLink, notificationTime?: number, customClass?: string): void {
    this.notificationSubject.next({ title, message, type, link, notificationTime, customClass });
  }

  public getNotificationSubject(): Observable<Notification> {
    return this.notificationSubject;
  }
}
